(function(_, $) {

	// *************************************************************************
	// Default options
	// *************************************************************************

	var defaultOptions = {
		mobileBreakpoint: 767,
		// mobileBreakpoint: 560,
	};

	// *************************************************************************
	// Scrolling animation class
	// *************************************************************************
	function ScrollingAnimation(elements, options) {
		this.elements = elements;
		this.options = options;
		this.animationId = null;
		this.lastAbsoluteScrollTop = null;
		this.$window = $(window);

		this.init();
	}
	ScrollingAnimation.prototype = {
		constructor: ScrollingAnimation,

		//
		// Initialization
		//
		init: function() {
			var self = this;
			this.elements.each(function() {
				self.initElementProperties(this);
			});

			// this.runAnimation();
			this.$window.on("resize orientationchange", this.onResize.bind(this));
			this.onResize();
		},

		initElementProperties: function(element) {
			var $element = $(element);

			if ($element.hasClass("parallax1")) {
				this.initParallax1(element);
			}
			else if ($element.hasClass("parallax2")) {
				this.initParallax2(element);
			}

		},

		initParallax1: function(element) {
			element.scrollAnimationState = function(absoluteScrollTop) {
				var browserHeight = window.innerHeight;

				var keyframe = absoluteScrollTop / browserHeight;
				if (keyframe < 0) { keyframe = 0; }
				if (1 < keyframe) { keyframe = 1; }

				var value = (browserHeight / 3) * keyframe;
				return { transform: "translateY(" + value + "px)" };
			}
		},

		initParallax2: function(element) {
			element.scrollAnimationState = function(absoluteScrollTop) {
				var $this = $(this);
				var browserHeight = window.innerHeight;
				var elementTop = $this.offset().top;
				var elementHeight = $this.height();

				if (browserHeight <= 0) { browserHeight = 1; }
				var keyframe = (absoluteScrollTop - elementTop + browserHeight) / browserHeight;

				if (keyframe < 0) { keyframe = 0; }
				if (1 < keyframe) { keyframe = 1; }

				var value = (browserHeight / 4) - (browserHeight / 4) * keyframe;
				return { transform: "translateY(" + value + "px)" };
			}
		},


		//
		// Events
		//
		runAnimation: function() {
			this.animateFrame();
			this.animationId = _.requestAnimationFrame(this.runAnimation.bind(this));
		},

		cancelAnimation: function() {
			if (this.animationId !== null) {
				_.cancelAnimationFrame(this.animationId);
				this.animationId = null;
			}
		},

		onResize: function() {
			if (this.options.mobileBreakpoint === null || this.options.mobileBreakpoint < this.$window.width()) {
				if (this.animationId === null) {
					this.runAnimation();
				}
			} else {
				this.cancelAnimation();
			}
		},


		//
		// Animations
		//
		animateFrame: function() {
			var self = this;
			var absoluteScrollTop = this.$window.scrollTop();

			if (absoluteScrollTop != this.lastAbsoluteScrollTop) {
				this.lastAbsoluteScrollTop = absoluteScrollTop;

				this.elements.each(function() {
					self.animateElement(this, absoluteScrollTop);
				});
			}
		},

		animateElement: function(element, absoluteScrollTop) {
			var updatedStyle = element.scrollAnimationState(absoluteScrollTop);
			if (updatedStyle) {
				$(element).css(updatedStyle);
			}
		},
	};

	// *************************************************************************
	// jQuery plugin
	// *************************************************************************

	$.fn.scrollAnimation = function(options) {
		var elements = $(this);
		var opts = $.extend({}, options, defaultOptions);
		new ScrollingAnimation(elements, opts);
	};

})(window, jQuery);